class SwiperComponent extends HTMLElement {
    connectedCallback() {
    //   this.innerHTML = /* Your Swiper HTML goes here */;
      this.initializeSwiper();
      Fancybox.bind('[data-fancybox="gallery"]', {
        //
      });   
      setTimeout(function(){
        document.querySelector('swiper-component .main-slider').swiper.slideTo(0);
      }, 900);
    }
  
    initializeSwiper() {

        var swiperElement = this.querySelector('.main-slider');
        var swiperElement2 = this.querySelector('.thumbs-slider');

        var galleryThumbs = new Swiper(swiperElement2, {
              spaceBetween: 10,
              slidesPerView: 'auto',
              freeMode: true,
              watchSlidesProgress: true,
              mousewheel: {
                forceToAxis: true
              },
              breakpoints: {
                992: {
                  direction: 'vertical',
                  slidesPerView: 'auto',
                },
              },
        });
        
        var swiper = new Swiper(swiperElement, {
            loop: false,
            autoHeight: true,
            pagination: {
              el: this.querySelector('.swiper-pagination'),
            },
            thumbs: {
              swiper: galleryThumbs
            }
        });

        // Sync thumbs-wrapper height to the main slide's rendered height.
        // Must run AFTER the main image actually paints, otherwise (first load,
        // uncached lazy image) offsetHeight is ~0 and the thumbs slider breaks.
        var syncThumbsHeight = () => {
          if (window.innerWidth > 992) {
            var slideHeight = this.querySelector('.main-slider .swiper-slide').offsetHeight;
            if (!slideHeight) return;
            this.querySelector('.thumbs-wrapper').style.height = slideHeight + 'px';
            this.querySelector('[thumbsslider]').style.height = slideHeight + 15 + 'px';
            galleryThumbs.update();
          }
        };

        // Tie the height calc to the real image-load signal instead of a fixed delay.
        var mainImage = this.querySelector('.main-slider .swiper-slide img');
        if (mainImage) {
          if (mainImage.complete && mainImage.naturalHeight) {
            syncThumbsHeight();
          } else {
            mainImage.addEventListener('load', syncThumbsHeight, { once: true });
            mainImage.addEventListener('error', syncThumbsHeight, { once: true });
          }
          // Recompute on any later size change (image swap, viewport resize, fonts).
          if (typeof ResizeObserver !== 'undefined') {
            new ResizeObserver(syncThumbsHeight).observe(
              this.querySelector('.main-slider .swiper-slide')
            );
          }
        }
        window.addEventListener('resize', syncThumbsHeight);

    }
  }

customElements.define('swiper-component', SwiperComponent);
  